export const meta = {
  id: 'A06',
  slug: 'minhas-formacoes',
  title: 'Conheça suas Formações',
  description: 'Entenda o que é uma Formação e como acompanhar os programas associados a você.',
  profile: 'student',
  category: 'formacoes',
  type: 'screen',
  status: 'published',
  order: 110,
  keywords: ['formações', 'minhas formações', 'programa', 'etapas', 'componentes', 'progresso'],
  previous: 'A05',
  next: 'A07',
  related: ['A05', 'A07', 'A09'],
  updatedAt: '2026-08-17',
  appVersion: 'v1'
}

# Conheça suas Formações

Uma **Formação** é um programa estruturado de desenvolvimento. Ela pode combinar diferentes experiências, e por isso não é apenas um curso maior.

Uma Formação pode incluir Treinamentos, atividades práticas, estudos de caso, role plays, aulas ao vivo, Mentorias, Evidências e checkpoints.

## Como a Formação é organizada

**Formação → Etapas → Componentes**

Em **Minhas Formações**, você visualiza as Formações às quais está associado e pode acompanhar a situação e o progresso disponíveis para cada uma.

<HelpImage alt="Lista de Formações associadas ao Aluno" pendingId="A06.1" />

## O que observar

Ao abrir uma Formação, procure seu objetivo, as etapas, os componentes, o progresso e a próxima ação disponível.

<Callout type="concept">
  **Treinamento** ensina um conteúdo. **Formação** estrutura um programa de desenvolvimento. **Jornada** organiza o caminho entre experiências.
</Callout>
